module.exports = __webpack_public_path__ + "static/media/mail.0b563c19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/components/Main/mail.svg
// module id = 115
// module chunks = 0